import Markdown from "react-markdown";
import styled from "@emotion/styled";

export default styled(Markdown)`
  a {
    text-decoration: underline;
  }
`;
